import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SessionService } from '../login/session.service';

@Injectable({
  providedIn: 'root'
})
export class CabecalhoService {

  private ambienteAtual = new BehaviorSubject<string>('site');
  private paginaAtual = new BehaviorSubject<string>('home');
  private statusLogado = new BehaviorSubject<boolean>(false);
  private ehProdutorLogado = new BehaviorSubject<boolean>(false);

  constructor(private sessionService: SessionService) { }

  logado = this.statusLogado.asObservable();
  pagina = this.paginaAtual.asObservable();
  ambiente = this.ambienteAtual.asObservable();
  ehProdutor = this.ehProdutorLogado.asObservable();

  alterarStatusLogado(logado: boolean) {
    this.statusLogado.next(logado);
  }

  alterarPagina(pagina: string) {
    this.paginaAtual.next(pagina);
  }

  alterarAmbiente(ambiente: string) {
    this.ambienteAtual.next(ambiente);
  }

  verificarSeEhProdutor() {
    this.ehProdutorLogado.next(this.sessionService.getEhProdutor());
  }
}
